import React from 'react';
import FullPageMessage from 'projects/components/FullPageMessage';
import { useProjectModal } from '../contexts/ProjectModalContext';

const SurveyNotFound = () => {
  const { showProjectModal } = useProjectModal();
  
  return (
    <FullPageMessage
      header='Survey not Found'
      body='The survey you are looking for does not exist or you do not have access to it.'
      onClick={showProjectModal}
      buttonText='See Your Projects'
    />
  );
};

export default SurveyNotFound;
